import React from 'react'

function Footer() {
    return (
        <div className='Footer'>
            2020 | Sunbeam | All Rights Reserved
        </div>
    )
}

export default Footer
